import { useActivatedIntegration } from '../../../use-activated-integration';
import { INTEGRATION_PROVIDERS } from '@vy/types';

export function useQuickbooksEnabled() {
  return useActivatedIntegration(INTEGRATION_PROVIDERS.quickBooks, {
    suspense: true,
  });
}
